/* eslint react/prop-types: 0 */
import React from 'react';
import { KIND, portKinds } from '../../helpers/traceability/modulePorts';
import './boardModules.scss';

/**
 * El texto del sticker. Los de dos renglones (MD INF, SAT 1) llevan el segundo
 * más chico, como en los impresos; el segundo IIC se imprime igual que el
 * primero.
 */
const stickerText = (label) => {
  if (/^IIC/.test(label)) return { main: 'IIC' };
  const motor = label.match(/^(MD|MI)(Inf|Sup)$/);
  if (motor) return { main: motor[1], sub: motor[2].toUpperCase() };
  const sat = label.match(/^SAT(\d)$/);
  if (sat) return { main: 'SAT', sub: sat[1] };
  const numbered = label.match(/^P(\d)$/);
  return { main: numbered ? numbered[1] : label };
};

/**
 * El sticker de un puerto, dibujado a partir de las categorías de pins que
 * acepta: un color por categoría, con el fondo partido como en los impresos --
 * entero con una, arriba y abajo con dos, dos arriba y una abajo con tres,
 * cuadrantes con cuatro.
 *
 * `state` le pone el borde: 'wrong' para el puerto en el que no va, 'right' para
 * los que se sugieren.
 */
const PortSticker = ({ board, label, state }) => {
  const kinds = portKinds(board, label);
  const { main, sub } = stickerText(label);
  const classes = ['portSticker', `parts-${Math.min(kinds.length, 4) || 1}`];
  if (state) classes.push(`is-${state}`);
  if (main.length > 1) classes.push('is-small');
  if (sub) classes.push('has-sub');
  if (kinds.includes(KIND.MOTOR)) classes.push('is-motor');

  return (
    <span className={classes.join(' ')} title={label}>
      {kinds.slice(0, 4).map((kind) => <span key={kind} className={`part kind-${kind}`} />)}
      <span className="text">
        {main}
        {sub && <span className="sub">{sub}</span>}
      </span>
    </span>
  );
};

export default PortSticker;
